<div class="search-result">
  <div *ngIf="!response()?.success" class="state state--error">
    {{ response()?.error || ('SEARCH_RESULTS.SEARCH_FAILED' | translate) }}
  </div>

  <div *ngIf="response()?.success && results().length === 0" class="state">
    {{ 'SEARCH_RESULTS.NO_RESULTS' | translate }}
  </div>

  <cdk-virtual-scroll-viewport
    *ngIf="response()?.success && results().length"
    class="search-result__viewport"
    [itemSize]="rowHeight"
    [minBufferPx]="minBufferPx"
    [maxBufferPx]="maxBufferPx"
    (scrolledIndexChange)="onScrolledIndex($event)"
  >
    <div *cdkVirtualFor="let row of rows()" class="search-result__row" [style.height.px]="rowHeight">
      <app-thumbnail
        *ngFor="let item of row"
        class="search-result__thumbnail"
        [thumbnailTemplate]="ThumbnailTemplate.TEMPLATE2"
        [showObjects]="true"
        [showEventsCounter]="false"
        [cameraId]="item.cameraId"
        [edgeId]="item.edgeId"
        [objects]="item.searchObjects || []"
        [searchEvents]="item.searchEvents || []"
        [optionsInput]="thumbnailOptions(item)"
        [defaultThumbnail]="item.thumbnailUrl || ''"
      ></app-thumbnail>
    </div>
  </cdk-virtual-scroll-viewport>

  <div *ngIf="loadingMore()" class="state search-result__loading">
    {{ 'COMMON.LOADING' | translate }}
  </div>
</div>
